import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateConversionService {
  convertDateToISO(date: string): string {
    if (!date) return '';
    const [day, month, year] = date.split('/');
    return `${year}-${month}-${day}`;
  }

  convertDateToDDMMYYYY(date: string): string {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  }

  convertTimeToHHMM(time: string): string {
    if (!time) return '';
    const [hour, minute, second] = time.split(':');
    return `${hour}:${minute}`;
  }

  convertTimeToHHMMSS(time: string): string {
    if (!time) return '';
    const [hour, minute] = time.split(':');
    return `${hour}:${minute}:00`;
  }
}
